$(()=> {
    const $mod = $('.module-right-toolbar'),
        goTop = $mod.find('.top');

    let needFixToRight = () => {
        if ($(window).width() <= 1440 ) {
            $mod.css({
                'left': 'auto',
                'right': '0'
            })
        }
    }

    let needShow = () => {

        if ($(window).scrollTop() >= $('.module-pannel-menu').offset().top - 10)  {
            goTop.css({
                'display': 'block'
            }).show()
        } else {
            goTop.hide()
        }

    }

    $mod.find('.top').click(()=> {
        window.scrollTo(0, 0)
    })


    $(window).on('scroll', _.throttle(needShow, 200))

    needShow()
    needFixToRight()

})



// WEBPACK FOOTER //
// ./src/module/right-toolbar/right-toolbar.js